var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarShine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.556 15.842l-4.2-1.179-1.245-3.979-1.244 3.98-4.2 1.178 4.2 1.18L38.11 21l1.245-3.979 4.2-1.179zM41.222 7l1.711 2.947-1.71 2.948 3.11-1.621 3.111 1.62-1.71-2.947L47.443 7l-3.11 1.621L41.221 7zM46.667 16.358l-2.334-1.253 1.323 2.21-1.323 2.211 2.334-1.252L49 19.526l-1.322-2.21L49 15.106l-2.333 1.252z",
    fill: "#54DCF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.333 19.833H28l21 10.5c.306.168.616.328.92.486 1.95 1.01 3.747 1.942 3.747 4.181v2.333H48.58A6.965 6.965 0 0142 42a7.017 7.017 0 01-6.603-4.667H20.58A6.965 6.965 0 0114 42a7.017 7.017 0 01-6.603-4.667H2.333v-7A4.65 4.65 0 017 25.667h2.333l7-5.834zm1.167 3.5L12.25 28h23.917l-9.334-4.667H17.5zm-1.025 9.192a3.5 3.5 0 10-4.95 4.95 3.5 3.5 0 004.95-4.95zm28 0a3.5 3.5 0 10-4.95 4.95 3.5 3.5 0 004.95-4.95z",
    fill: "#54DCF2"
  })));
}
export default SvgIconCarShine;